import { combineReducers } from 'redux';
import { IGetLMSFieldsState } from 'redux/types/LoanBook.types';

import getLMSFieldsReducer, {
  getLMSFieldsInitialState,
} from './GetLMSFields.slice';

export interface ILoanBookState {
  lmsFields: IGetLMSFieldsState;
}

export const loanBookInitialState = {
  lmsFields: getLMSFieldsInitialState,
};

export const loanBookReducer = combineReducers({
  lmsFields: getLMSFieldsReducer,
});
